// Labels for the enum values the API uses; translated through t() where they are shown.
export const STATUS_LABELS = {
  new: "New",
  extracted: "Extracted",
  needs_review: "Needs review",
  approved: "Approved",
  booked: "Booked",
  paid: "Paid",
  archived: "Archived",
  rejected: "Rejected",
  draft: "Draft",
  objected: "Objected"
};

export const STATUS_COLORS = {
  new: "default",
  extracted: "blue",
  needs_review: "orange",
  approved: "cyan",
  booked: "green",
  paid: "green",
  archived: "default",
  rejected: "red",
  draft: "default",
  objected: "volcano"
};

export const TAX_MODE_LABELS = {
  regular: "Regular (VAT shown)",
  reverse_charge: "Reverse charge (§ 13b UStG)",
  small_business: "Small business (§ 19 UStG)",
  intra_eu: "Intra-EU acquisition",
  exempt: "Tax exempt",
  none: "No VAT"
};

export const KIND_LABELS = {
  supplier_invoice: "Supplier invoice",
  receipt: "Receipt",
  credit_note: "Credit note",
  bank_statement: "Bank statement",
  contract: "Contract",
  customer_invoice_copy: "Copy of own invoice",
  tax_notice: "Tax notice",
  payroll_document: "Payroll document",
  self_billing: "Self-billing credit note (Gutschrift)",
  other: "Other"
};

// Kinds the review form may set; a self-billing Gutschrift is only created in its own dialog.
export const EDITABLE_KINDS = Object.keys(KIND_LABELS).filter(k => k !== "self_billing");

// § 14 UStG Pflichtangaben keys from the server → labels.
export const MISSING_LABELS = {
  supplier_name: "Supplier name",
  supplier_address: "Supplier address",
  supplier_tax_id: "Supplier tax number or VAT ID",
  invoice_number: "Invoice number",
  invoice_date: "Invoice date",
  delivery_date: "Delivery / service date",
  description: "Description of goods or services",
  net_per_rate: "Net amount per tax rate",
  tax_rate_amount: "Tax rate and tax amount",
  recipient_name: "Invoice addressed to us",
  gross: "Gross amount",
  tax_rate: "Tax rate"
};

// The German category labels in kontenrahmen are translated here by key.
export const CATEGORY_LABELS = {
  materials: "Materials / goods",
  subcontractors: "Subcontractors",
  small_tools: "Tools and small equipment",
  equipment: "Machinery and equipment (asset)",
  office_equipment: "Office equipment (asset)",
  vehicle: "Vehicle (asset)",
  gwg: "Low-value asset (GWG)",
  fuel: "Fuel / running vehicle costs",
  vehicle_repairs: "Vehicle repairs",
  vehicle_insurance: "Vehicle insurance",
  vehicle_tax: "Vehicle tax",
  vehicle_leasing: "Vehicle leasing / rental",
  rent: "Rent",
  energy: "Electricity, gas, water",
  heating: "Heating",
  premises_maintenance: "Premises maintenance",
  insurance: "Insurance",
  memberships: "Memberships (chamber, guild)",
  telecom: "Phone / mobile",
  internet: "Internet",
  software: "Software / licences",
  office_supplies: "Office supplies",
  postage: "Postage",
  literature: "Trade literature",
  training: "Training",
  advertising: "Advertising",
  entertainment: "Entertainment",
  gifts: "Gifts",
  travel: "Travel expenses",
  travel_employees: "Travel expenses employees",
  equipment_repairs: "Equipment repairs",
  equipment_leasing: "Equipment leasing",
  equipment_rent: "Equipment / scaffolding rental",
  legal_consulting: "Legal and consulting",
  tax_advisor: "Tax advisor",
  bank_fees: "Bank fees",
  interest: "Interest",
  operating_supplies: "Operating supplies",
  cleaning: "Cleaning",
  other: "Other costs",
  private: "Private (not deductible)"
};

export const INBOX_STATUSES = ["new", "extracted", "needs_review"];
export const LOCKED_STATUSES = ["booked", "paid", "archived", "objected"];
export const ACCEPT =
  ".pdf,.jpg,.jpeg,.png,.webp,.xml,application/pdf,image/jpeg,image/png,image/webp,application/xml,text/xml";
export const MAX_FILES = 10;
export const POLL_MS = 3000;
